import { Input as AntdInput, DatePicker, Form } from 'antd'
import Button from 'components/Button/index'
import CalendarPicker from 'components/CalendarPicker'
import FilterDiv from 'components/FilterDiv'
import Flex from 'components/Flex'
import Inputs from 'components/Form/Input'
import {
  default as Radio,
  default as RadioButton,
} from 'components/Form/RadioButton'
import TextAreas from 'components/Form/TextArea'
import RangeSlider from 'components/RangeSlider/index'
import Select from 'components/Select/index'
import SelectDropDown from 'components/SelectWithCheckBox'
import { RadioGroup } from 'components/UIComponents/FormStyles'
import DeleteIcon from 'components/icons/DeleteIcon'
import LinkIcon from 'components/icons/LinkIcon'
import PlusWhiteIcon from 'components/icons/PlusBlueIcon'
import { format, parse } from 'date-fns'
import {
  MenuFlex,
  SubmitFlex,
} from 'modules/Drives/Components/DriveTable/Drivefilter/Style/style'
import moment from 'moment'
import React, { Fragment, useEffect, useState } from 'react'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
import SuccessMessage from 'utils/SuccessMessage'
import { EmptySpan } from '../../../../components/UIComponents/CommonStyledDiv'
import ClosedCircleIcon from '../../../../components/icons/ClosedCircleIocn'
import {
  ChangeDiv,
  Commondiv,
  Diveder,
  FormItem,
  IconWrapper,
  ModeFlex,
  NoneContainer,
  NoneWrapper,
  SessionFlex,
  StartSpan,
  TextWrapper,
  TimeDivItem,
  TimeDivText,
  TimeInfoSpan,
  TotalTimeDiv,
} from '../../Components/CreateSlotDrawer/style'
import SelectMode from '../CreateSlotDrawer/Components/SelectMode/index'
import CandidateDetails from './Components/CandidateDetails'
import { RadioOptions, assessmentOptions, optionTime } from './constant'

const { TextArea } = AntdInput

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 10px;
`
const AntdInputStyle = styled(AntdInput)`
  ::placeholder {
    font-size: 16px;
  }
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_BASE};
  color: ${COLORS.GREY_T_40};
  width: ${props => (props.width ? props.width : 'auto')};
  height: ${props => (props.height ? props.height : '48px')};
  padding: ${props => (props.padding ? props.padding : '')};
  border-radius: 8px;
  box-shadow: none;
  border-color: ${props => (props.error ? 'red' : '#e9e9e9')};
  :focus {
    border-color: #e9e9e9;
    box-shadow: none;
  }
  :hover {
    border-color: #e9e9e9;
  }
  :not(.ant-input-affix-wrapper-disabled):hover {
    border-color: #e9e9e9 !important;
  }
  .ant-input-affix-wrapper-focused {
    box-shadow: none;
    border-right-width: 0px !important;

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
`

const CustomDatePicker = styled(DatePicker.RangePicker)`
  width: 100%;
  height: 45px;
`

const dropdownRender = (
  menu,
  interviewRoundInfo,
  onClickNone,
  linkPanelData,
  name
) => {
  return (
    <>
      {interviewRoundInfo?.interview?.interviewType === 'ASSESMENT' && (
        <Fragment>
          <NoneContainer onClick={onClickNone}>
            <Flex column>
              <TextWrapper>Available</TextWrapper>
              <Flex row spaceBetween>
                <NoneWrapper centerVertically>None</NoneWrapper>
                <RadioGroup
                  value={
                    linkPanelData[name]?.panel[0]?.id === null
                      ? 'None'
                      : linkPanelData[name]?.panel.map(({ id }) => id)
                  }
                >
                  <RadioButton value={'None'} />
                </RadioGroup>
              </Flex>
            </Flex>
          </NoneContainer>
          <Diveder />
        </Fragment>
      )}
      {menu}
    </>
  )
}

const ScheduleInterviewForm = ({
  form,
  selectedCandidate,
  rolesMetrics,
  setChangeLocationDrawer,

  driveData,
  candidateDeatils,

  linkPanelData,

  isSingleOrBulk,
  interviewType,

  candidates,
  setCandidates,
  handleIterviewRound,

  onDurationChange,

  onChangeMode,
  onChangeLink,
  onClickNone,
  onSelectInterview,
  onSubmitFormData,

  onChangeTimeRange,

  interviewList,
  getUpdatedList,
  isBulk,

  checked,
  locations,
  dateArr,
  setDateArr,
  singleLocationChange,
  setLinkPanelData,
  onMultiChangeDates,
  interviewRoundInfo,

  interviewValueInfo,

  timeRange,

  formSubmitted,
}) => {
  let linkPanelInitialValue = {
    link: interviewRoundInfo?.link,
    panel: [
      {
        id: null,
        firstName: null,
        lastName: null,
      },
    ],
  }
  const [open, setOpen] = useState(false)
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  useEffect(() => {
    form.setFieldsValue({
      linkAndPanel: [linkPanelInitialValue],
    })
  }, [])

  useEffect(() => {
    getUpdatedList()
  }, [linkPanelData])

  const addToForm = () => {
    getUpdatedList()
    if (interviewRoundInfo?.mode === 'OFFLINE') {
      setLinkPanelData([
        ...linkPanelData,
        {
          panel: [
            {
              id: null,
              firstName: null,
              lastName: null,
            },
          ],
        },
      ])
    } else if (
      interviewRoundInfo?.mode === 'EXTERNAL_LINK' &&
      interviewRoundInfo?.interview?.interviewType === 'ASSESMENT'
    ) {
      setLinkPanelData([...linkPanelData, { link: null }])
    } else {
      setLinkPanelData([...linkPanelData, linkPanelInitialValue])
    }
  }

  const onRemove = name => {
    setLinkPanelData(linkPanelData?.filter((data, index) => index !== name))
  }

  const copyLinkText = link => {
    if (link) {
      navigator.clipboard.writeText(link)
      SuccessMessage('Link Copied!!')
    }
  }

  const handleLocation = () => {
    setChangeLocationDrawer(true)
  }

  const branchName = locations?.map(location => location?.branchName)
  const cities = locations?.map(location => location?.city)
  const states = locations?.map(location => location.state)
  const countries = locations?.map(location => location?.country)

  const locationData = {
    branchName: branchName?.[0] || '',
    cities: cities?.[0] || '',
    states: states?.[0] || '',
    countries: countries?.[0] || '',
  }

  const locationChangeData = {
    branchName: singleLocationChange?.branchName,
    cities: singleLocationChange?.city,
    states: singleLocationChange?.state,
    countries: singleLocationChange?.country,
  }

  const locationParts = [
    locationData?.branchName,
    locationData?.cities,
    locationData?.states,
    locationData?.countries,
  ]

  const locationValue = locationParts.filter(Boolean).join(', ')
  const locationValueChange = `${locationChangeData.branchName} ${locationChangeData.cities}, ${locationChangeData.states}, ${locationChangeData.countries}`

  const formatDate = dateString => {
    const date = parse(dateString, 'yyyy-MM-dd', new Date())
    const formattedDate = format(date, 'd MMM, yyyy - EEE')
    return formattedDate
  }

  const handleDateRemove = indexToRemove => {
    const updatedDateArr = dateArr?.filter(
      (date, index) => index !== indexToRemove
    )
    setDateArr(updatedDateArr)
    onMultiChangeDates(updatedDateArr)
  }

  const compareDates = (date1, date2) => {
    return new Date(date1) - new Date(date2)
  }
  const [date, setDate] = useState([])

  const onsubmitDate = () => {
    setDateArr(date)
  }
  const pickerChangeHandler = dates => {
    let datesString = dates.map(date =>
      moment(date?.unix * 1000).format('YYYY-MM-DD')
    )
    setDate(datesString)

    datesString.sort(compareDates)
    setDateArr(datesString)
    onMultiChangeDates(datesString)
  }

  const menu = (
    <div style={{ width: '16rem' }}>
      <MenuFlex column>
        <div
          style={{ marginTop: '2rem', marginLeft: '1rem', marginRight: '0rem' }}
        >
          <CalendarPicker
            multiple={true}
            numberOfMonths={1}
            minDate={new Date()}
            onCalenderChange={pickerChangeHandler}
          />
        </div>

        <SubmitFlex right>
          <Button.Secondary
            text="Cancel"
            onClick={() => {
              setOpen(false)
            }}
          />
          <Button.Primary
            text="Confirm"
            onClick={() => {
              setOpen(false)
              onsubmitDate()
            }}
          />
        </SubmitFlex>
      </MenuFlex>
    </div>
  )
  useEffect(() => {
    form.setFieldsValue({
      location: locationValue,
    })
  }, [locationValue])
  return (
    <Form
      scrollToFirstError
      onFinish={onSubmitFormData}
      id={'scheduleForm'}
      form={form}
      layout="vertical"
      initialValues={{
        linkAndPanel: [linkPanelInitialValue],
      }}
    >
      {isSingleOrBulk && (
        <CandidateDetails
          selectedCandidate={selectedCandidate}
          count={candidateDeatils?.candidateList?.count}
          isBulk={isBulk}
        />
      )}

      <FormItem
        name={'interviewRound'}
        rules={[{ required: true, message: 'Please select round name!' }]}
      >
        <TotalTimeDiv>
          Round Name<StartSpan>*</StartSpan>
        </TotalTimeDiv>
        <Select
          OptionData={rolesMetrics[0]?.rounds}
          nameParam="roundName"
          valueParam="roundName"
          placeholder="Round Name"
          onChange={handleIterviewRound}
          value={interviewRoundInfo?.interview?.interviewRound}
          disabled={true}
        />
      </FormItem>
      <FormItem
        name={'interviewType'}
        rules={[
          {
            required: false,
            message: 'Please select Interview type!',
          },
        ]}
      >
        <TotalTimeDiv>
          Interview Type <StartSpan>*</StartSpan>
        </TotalTimeDiv>
        <RadioGroup
          spaceBetween
          value={interviewRoundInfo?.interview?.interviewType}
        >
          {RadioOptions?.map((item, index) => {
            return (
              <Radio
                key={index + item?.label}
                border={true}
                label={item?.label}
                value={item?.value}
                width={'100%'}
                disable={true}
              />
            )
          })}
        </RadioGroup>
      </FormItem>
      {interviewRoundInfo?.interview?.interviewType === 'ASSESMENT' && (
        <FormItem>
          <TotalTimeDiv>
            Assesment Type <StartSpan>*</StartSpan>
          </TotalTimeDiv>
          <RadioGroup
            spaceBetween
            value={interviewRoundInfo?.interview?.assesmentType}
          >
            {assessmentOptions?.map((item, index) => (
              <Radio
                key={index + item?.label}
                border={true}
                label={item?.label}
                value={item?.value}
                width={'100%'}
                disable={true}
              />
            ))}
          </RadioGroup>
        </FormItem>
      )}
      {interviewRoundInfo?.interview?.interviewType == 'GROUP' && (
        <FormItem
          marginbottom={'0px'}
          name={'candidatesPerGroup'}
          rules={[
            {
              required: true,
              message: 'Please select no. of candidates per group!',
            },
          ]}
        >
          <Commondiv padding={'4px'}>
            <TotalTimeDiv>Select no. of candidates per group</TotalTimeDiv>
            <RangeSlider
              inputValue={candidates}
              setInputValue={setCandidates}
              min={0}
              max={20}
              percentage={false}
              sliderrules={[
                {
                  required: true,
                  message: 'required',
                },
                {
                  validator: (_, value) => {
                    if (value >= 0 && value <= 100) {
                      return Promise.resolve()
                    } else {
                      return Promise.reject(new Error('Not Valid'))
                    }
                  },
                },
              ]}
              inputDis
            />
          </Commondiv>
        </FormItem>
      )}
      <Flex>
        <FormItem
          name={'mode'}
          rules={[
            {
              validator: (_, value) => {
                if (formSubmitted && !value) {
                  return Promise.reject(new Error('Please select mode!'))
                }
                return Promise.resolve()
              },
            },
          ]}
          validateTrigger="onChange"
        >
          <ModeFlex row centerVertically>
            <Flex column>
              <TotalTimeDiv>
                Mode<StartSpan>*</StartSpan>
              </TotalTimeDiv>
              <SelectMode
                onChange={onChangeMode}
                placeholder={'Add Mode'}
                disabled={
                  (driveData?.driveMode !== 'VIRTUAL_DRIVE' &&
                    interviewRoundInfo?.interview?.interviewType === 'GROUP') ||
                  (driveData?.driveMode !== 'VIRTUAL_DRIVE' &&
                    interviewRoundInfo?.interview?.interviewType ===
                      'FACE_TO_FACE') ||
                  interviewRoundInfo?.interview?.interviewType ===
                    'EXTERNAL_ASSESMENT'
                }
                isVirtual={driveData?.driveMode === 'VIRTUAL_DRIVE'}
                value={interviewValueInfo?.mode}
                interviewType={interviewType}
                getPopupContainer={() => document.getElementById('mode')}
              />
            </Flex>
          </ModeFlex>
        </FormItem>
      </Flex>
      <TotalTimeDiv>
        Date <StartSpan>*</StartSpan>
      </TotalTimeDiv>
      <FilterDiv
        calendar={true}
        overlayMenu={menu}
        open={open}
        setOpen={setOpen}
        width={'100%'}
        dateValue={
          dateArr?.length > 1
            ? dateArr.length + ' Days Selected'
            : dateArr?.length == 1
            ? dateArr.length + ' Day Selected'
            : ''
        }
        onOpenChange={() => setIsMenuOpen(!isMenuOpen)}
      />
      <FormItem>
        {dateArr?.length > 0 && (
          <TotalTimeDiv style={{ marginTop: '1.5rem' }}>
            Selected Dates <StartSpan>*</StartSpan>
          </TotalTimeDiv>
        )}
        <GridContainer>
          {dateArr?.map((date, index) => (
            <div key={index + 'dateDisplay'}>
              <AntdInputStyle
                width={'100%'}
                value={formatDate(date)}
                suffix={
                  <EmptySpan
                    style={{ paddingTop: '10px' }}
                    onClick={() => handleDateRemove(index)}
                  >
                    <ClosedCircleIcon />
                  </EmptySpan>
                }
              />
            </div>
          ))}
        </GridContainer>
      </FormItem>
      <FormItem ismargin>
        <SessionFlex row centerVertically>
          <div>
            <FormItem
              name={'duration'}
              rules={[
                {
                  validator: (_, value) => {
                    if (formSubmitted && !value) {
                      return Promise.reject(
                        new Error('Please select duration!')
                      )
                    }
                    return Promise.resolve()
                  },
                },
              ]}
              validateTrigger="onChange"
            >
              <TotalTimeDiv>
                Duration <StartSpan>*</StartSpan>
              </TotalTimeDiv>
              <Select
                width="182px"
                OptionData={optionTime}
                nameParam="label"
                valueParam="value"
                placeholder="Duration"
                onChange={onDurationChange}
                id={'duration'}
                showSearch
                value={interviewValueInfo?.duration}
              />
            </FormItem>
          </div>
          <FormItem
            name={'timeRange'}
            rules={[
              {
                required: false,
                message: 'Please select Time Range!',
              },
            ]}
          >
            <TotalTimeDiv>
              <TimeDivItem>
                <div>
                  {' '}
                  Time Range<StartSpan>*</StartSpan>
                </div>

                <TimeDivText>&#40; GMT+05:30 &#41; Asia/Kolkata</TimeDivText>
              </TimeDivItem>
            </TotalTimeDiv>
            <CustomDatePicker
              format={'HH:mm'}
              placeholder={['StartTime', 'EndTime']}
              picker={'time'}
              onChange={onChangeTimeRange}
              value={[
                timeRange[0] ? moment(timeRange[0], 'HH:mm') : null, // Convert start time to moment object
                timeRange[1] ? moment(timeRange[1], 'HH:mm') : null, // Convert end time to moment object
              ]}
            />
          </FormItem>
        </SessionFlex>
      </FormItem>
      {interviewValueInfo?.mode === 'OFFLINE' && (
        <div>
          {checked === singleLocationChange.id ? (
            <Form.Item
              name={'location'}
              initialValue={locationValueChange}
              rules={[
                {
                  required: true,
                  message: 'Please enter the location!',
                },
              ]}
              validateTrigger="onSubmitFormData" // Set validateTrigger to 'onSubmit'
            >
              <Flex spaceBetween>
                <TotalTimeDiv>
                  Interview Location <StartSpan>*</StartSpan>
                </TotalTimeDiv>
                <ChangeDiv onClick={handleLocation}>Change</ChangeDiv>
              </Flex>
              <TextArea
                marginbottom={'0px'}
                placeholder={'Add Location'}
                type="text"
                value={locationValueChange}
              />
            </Form.Item>
          ) : (
            <>
              <Flex spaceBetween>
                <TotalTimeDiv>
                  Interview Location <StartSpan>*</StartSpan>
                </TotalTimeDiv>
                <ChangeDiv onClick={handleLocation}>Change</ChangeDiv>
              </Flex>

              <Form.Item
                name={'location'}
                initialValue={locationValue}
                rules={[
                  {
                    required: true,
                    message: 'Please enter the location!',
                  },
                ]}
              >
                <TextArea
                  marginbottom={'0px'}
                  placeholder={'Add Location'}
                  type="text"
                  value={locationValue}
                />
              </Form.Item>
            </>
          )}
        </div>
      )}

      {interviewValueInfo?.mode !== 'OFFLINE' && (
        <Form.List name="linkAndPanel">
          {(fields, { add, remove }) => {
            return (
              <>
                {fields.map(({ key, name, ...restField }) => (
                  <SessionFlex
                    spaceBetween
                    centerVertically
                    key={name + 'linkAndPanel'}
                  >
                    <FormItem>
                      <TotalTimeDiv>
                        Link <StartSpan>*</StartSpan>
                      </TotalTimeDiv>
                      <Inputs
                        width="100%"
                        suffix={
                          <IconWrapper
                            noBottom
                            onClick={() =>
                              copyLinkText(interviewRoundInfo?.link ?? '')
                            }
                          >
                            <LinkIcon />
                          </IconWrapper>
                        }
                        placeholder="Add Link"
                        value={interviewRoundInfo?.link ?? ''} // Set the initial value, or default to an empty string
                        onChange={e => onChangeLink(e, name)}
                        name={[name, 'link']}
                        type="url"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter valid link!',
                          },
                        ]}
                      />
                    </FormItem>
                    {(interviewRoundInfo?.interview?.interviewType !==
                      'ASSESMENT' ||
                      interviewRoundInfo?.interview?.interviewType !==
                        'EXTERNAL_ASSESMENT') && (
                      <FormItem
                        name={[name, 'panel']}
                        rules={[
                          {
                            required: true,
                            message: 'Please select interviewer!',
                          },
                        ]}
                      >
                        <TotalTimeDiv>
                          Interviewer/Panel {name + 1}
                        </TotalTimeDiv>
                        <div id={name + 1}>
                          <SelectDropDown
                            width="100%"
                            optionDivData={interviewList}
                            maxTagCount={1}
                            isInterviewer={true}
                            valueParam="_id"
                            nameParam="first_name"
                            lastNameParam="last_name"
                            optionLabelProp={'label'}
                            placement={'bottomLeft'}
                            placeholder={'Select Interviewers'}
                            dropdownMatchSelectWidth={false}
                            dropdownStyle={{ width: '20%' }}
                            value={
                              linkPanelData[name]?.panel[0]?.id === null
                                ? []
                                : linkPanelData[name]?.panel.map(({ id }) => id)
                            }
                            onChange={(value, option) =>
                              onSelectInterview(value, option, name)
                            }
                            getPopupContainer={() =>
                              document.getElementById(name + 1)
                            }
                          />
                        </div>
                      </FormItem>
                    )}

                    {isSingleOrBulk &&
                      (interviewRoundInfo?.interview?.interviewType !==
                        'ASSESMENT' ||
                        interviewRoundInfo?.interview?.interviewType !==
                          'EXTERNAL_ASSESMENT') && (
                        <IconWrapper
                          center
                          onClick={() => {
                            remove(name)
                            onRemove(name)
                          }}
                          disable={linkPanelData?.length === 1}
                        >
                          <DeleteIcon />
                        </IconWrapper>
                      )}
                  </SessionFlex>
                ))}
                {isSingleOrBulk &&
                  (interviewRoundInfo?.interview?.interviewType !==
                    'ASSESMENT' ||
                    interviewRoundInfo?.interview?.interviewType !==
                      'EXTERNAL_ASSESMENT') && (
                    <Form.Item>
                      <Button.Secondary
                        text={'Add'}
                        width="100%"
                        icon={<PlusWhiteIcon />}
                        dashed="true"
                        onClick={() => {
                          addToForm()
                          add()
                        }}
                      />
                    </Form.Item>
                  )}
              </>
            )
          }}
        </Form.List>
      )}
      {interviewValueInfo?.mode === 'OFFLINE' && (
        <Form.List name="linkAndPanel">
          {(fields, { add, remove }) => {
            return (
              <>
                {fields.map(({ key, name, ...restField }) => (
                  <SessionFlex
                    spaceBetween
                    centerVertically
                    key={name + 'offlinePanel'}
                  >
                    <FormItem
                      name={[name, 'panel']}
                      rules={[
                        {
                          required: true,
                          message: 'Please select interviewer!',
                        },
                      ]}
                    >
                      <TotalTimeDiv>Interviewer/Panel {name + 1}</TotalTimeDiv>
                      <div id={name + 1}>
                        <SelectDropDown
                          width="100%"
                          optionDivData={interviewList}
                          maxTagCount={1}
                          isInterviewer={true}
                          valueParam="_id"
                          nameParam="first_name"
                          lastNameParam="last_name"
                          optionLabelProp={'label'}
                          placement={'bottomLeft'}
                          placeholder={'Select Interviewers'}
                          dropdownMatchSelectWidth={false}
                          dropdownStyle={{ width: '20%' }}
                          mode={
                            interviewRoundInfo?.interview?.interviewType ===
                              'ASSESMENT' &&
                            linkPanelData[name]?.panel[0]?.id === null
                              ? ''
                              : 'multiple'
                          }
                          onChange={(value, option) =>
                            onSelectInterview(value, option, name)
                          }
                          value={
                            interviewRoundInfo?.interview?.interviewType ===
                              'ASSESMENT' &&
                            linkPanelData[name]?.panel[0]?.id === null
                              ? 'None'
                              : linkPanelData[name]?.panel[0]?.id === null
                              ? []
                              : linkPanelData[name]?.panel.map(({ id }) => id)
                          }
                          getPopupContainer={() =>
                            document.getElementById(name + 1)
                          }
                          dropdownRender={menu =>
                            dropdownRender(
                              menu,
                              interviewRoundInfo,
                              onClickNone,
                              linkPanelData,
                              name
                            )
                          }
                        />
                      </div>
                    </FormItem>

                    {isSingleOrBulk &&
                      interviewRoundInfo?.interview?.interviewType !==
                        'ASSESMENT' && (
                        <IconWrapper
                          center
                          onClick={() => {
                            remove(name)
                            onRemove(name)
                          }}
                          disable={linkPanelData?.length === 1}
                        >
                          <DeleteIcon />
                        </IconWrapper>
                      )}
                  </SessionFlex>
                ))}
                {isSingleOrBulk &&
                  interviewRoundInfo?.interview?.interviewType !==
                    'ASSESMENT' && (
                    <Form.Item>
                      <Button.Secondary
                        text={'Add'}
                        width="100%"
                        icon={<PlusWhiteIcon />}
                        dashed="true"
                        onClick={() => {
                          add()
                          addToForm()
                        }}
                      />
                    </Form.Item>
                  )}
              </>
            )
          }}
        </Form.List>
      )}
      <FormItem>
        <Flex spaceBetween>
          <TotalTimeDiv>Note/Instructions</TotalTimeDiv>
          <TimeInfoSpan>Visible to the candidate</TimeInfoSpan>
        </Flex>
        <TextAreas
          marginbottom={'0px'}
          name={'instructions'}
          placeholder={'Add Note for the Candidates'}
          required
          value={interviewValueInfo?.instructions} // Set the value here
        />
      </FormItem>
    </Form>
  )
}

export default ScheduleInterviewForm
